import { Container } from "@material-ui/core";
import { useStyles } from "./styles";

function PageContainer({children}) {
  const classes = useStyles()
  return (
    <Container maxWidth="md" className={classes.container}>
      {children}
    </Container>
  );
}

export default PageContainer;